/* src/app/sellout/view-sellout/view-sellout.component.css */
.variance-positive {
  color: #b45309;
  font-weight: 600;
}
.variance-negative {
  color: #b91c1c;
  font-weight: 600;
}
.variance-neutral {
  color: #15803d;
  font-weight: 600;
}
.sellout-details-table :is(th, td) {
  white-space: normal;
  vertical-align: top;
}
.sellout-details-table .p-datatable-wrapper {
  overflow-x: visible;
}
.sellout-details-table table {
  width: 100%;
  min-width: 100%;
  table-layout: fixed;
}
.sellout-details-table th {
  background: #f8fafc;
  color: #334155;
  font-size: 0.82rem;
  font-weight: 700;
}
.sellout-details-table th:nth-child(1),
.sellout-details-table td:nth-child(1) {
  width: 18%;
}
.sellout-details-table th:nth-child(2),
.sellout-details-table td:nth-child(2) {
  width: 22%;
}
.sellout-details-table th:nth-child(3),
.sellout-details-table td:nth-child(3) {
  width: 22%;
}
.sellout-details-table th:nth-child(4),
.sellout-details-table td:nth-child(4) {
  width: 17%;
}
.sellout-details-table th:nth-child(5),
.sellout-details-table td:nth-child(5) {
  width: 21%;
}
.sellout-details-table th:nth-child(6),
.sellout-details-table td:nth-child(6) {
  width: 18%;
}
.stacked-cell {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  line-height: 1.35;
}
.compact-cell .stacked-cell > div {
  white-space: nowrap;
}
.validation-cell .stacked-cell > div {
  white-space: normal;
}
.cell-label {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 600;
}
.validation-message {
  color: #475569;
  font-size: 0.82rem;
  line-height: 1.4;
  word-break: break-word;
}
/*# sourceMappingURL=view-sellout.component-RVOWJKXP.css.map */
